import React from 'react';
import './Cooperants.css';
import trashIcon from './images/remove.svg';

function Cooperants({
  externalServices,
  setExternalServices,
  setTotalExpense,
  closeShowWorkLogModal,
}) {
  const removeCooperant = (removeIndex) => {
    setTotalExpense(
      (prevTotal) => prevTotal - parseFloat(externalServices[removeIndex].price)
    );
    setExternalServices(
      externalServices.filter((externalService, index) => index !== removeIndex)
    );
  };
  return (
    <div>
      {externalServices.length > 0 ? (
        <div className="cooperants">
          <div>
            <div className="external-services-title">Kooperant</div>
            {externalServices.map((externalService, index) => {
              return (
                <div className="cooperants-container" key={index}>
                  {externalService.cooperant}
                </div>
              );
            })}
          </div>
          <div>
            <div className="external-services-title">Cijena</div>
            {externalServices.map((externalService, index) => {
              return (
                <div
                  className="cooperants-container cooperants-price"
                  key={index + 10}
                >
                  {externalService.price.toFixed(2)} KM
                  <div
                    className="remove-cooperant"
                    onClick={() => removeCooperant(index)}
                  >
                    <img
                      src={trashIcon}
                      onClick={() => {}}
                      alt="Icon"
                      width={'12'}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div className="cooperants-empty-list">Lista je prazna</div>
      )}

      <button
        type="button"
        className="cooperants-button"
        onClick={closeShowWorkLogModal}
      >
        Zatvori
      </button>
    </div>
  );
}

export default Cooperants;
